<template>
  <a href="" @click.prevent="logout">
    <font-awesome-icon 
      v-show="icon === true" 
      icon="sign-out-alt" 
      class="header-menu-icon" />
    <span>ログアウト</span>
  </a>
</template>
<script setup>
import axios from "axios";
import Global from '../../js/constant.js'
import { computed, defineProps } from "vue"
import { useStore } from 'vuex'
import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { useRouter } from 'vue-router'

// store取得
const $store = useStore();
const $toast = useToast();
const $router = useRouter();

// props
defineProps({
  icon: {
    type: Boolean,
    required: true
  },
})

// --- computed ---
const account = computed(() => $store.state.core.account);

// action操作はdispatch
const save = () => $store.dispatch('save');

// mutation操作はcommit
const initState = () => $store.commit('initState')
const setClientErrors = (val) => $store.commit('setClientErrors', val)


// --- methods ---
const logout = () => {
  let params = { account_id : account.value.id }
  axios.post(Global.url.api_auto_logins_delete, params)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      initState()
      save()
      $toast.success("see you!", { position: 'bottom-left' })
      $router.push({ path : '/square' }, () => {})
      return
    }
    setClientErrors({func:"common/header/logout-anchor.vue::logout", params: { account_id : account.value.id }, errorMessage:JSON.stringify(res.data)})
    return
  })
  .catch(error=>{
    $toast.error('client error', { position: 'bottom-left' })
    setClientErrors({func:"common/header/logout-anchor.vue::logout", params: {account_id: account.value.id}, errorMessage:error})
  })
}
</script>
<!-- <script>
import { mapState, mapMutations, mapActions } from 'vuex'
import auto_logins from '../../../js/api/auto-logins'

export default {
  props:{
    icon: {
      type:Boolean,
      required:true,
    }
  },
  computed: {
    ...mapState([
      'account'
    ]),
  },

  methods:{
    ...mapMutations([
      'initState',
      'setClientErrors',
    ]),
    ...mapActions([
      'save',
    ]),
    logout : function () {
      let ret = auto_logins.delete(this.account.id)
      ret.then(res => {
        if (res.data.status != this.Global.api_status.success) this.setClientErrors({func:"common/header/logout-anchor.vue::logout", params: { account_id : this.account.id }, errorMessage:JSON.stringify(res.data)})
        this.initState()
        this.save()
        this.$toasted.success("see you!")
        this.$router.push({ path : '/square' }, () => {})
      })
      .catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({func:"common/header/logout-anchor.vue::logout", params: {account_id:this.account.id}, errorMessage:error})
      })
    }
  },
}
</script> -->